/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.SEND_TOAST]: (state, { title, message, type }) => {
    state.toastTitle = title;
    state.toastMessage = message;
    state.toastType = type;
  },

  [types.RESET_TOAST]: state => {
    state.toastTitle = null;
    state.toastMessage = null;
    state.toastType = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/toast/mutations.js